<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="fas fa-cookie-bite" class="q-mb-sm" />
			{{ $t('cookies_policy') }}
		</div>

		<q-tabs v-model="tab" color="secondary" class="shadow-1">
			<q-tab
				slot="title"
				v-for="(l, index) in laguages"
				:key="`t-${index}`"
				:name="`tab-${l.id}`"
				:label="l.name"
			/>

			<q-tab-pane v-for="(l, index) in laguages" :key="`tp-${index}`" :name="`tab-${l.id}`">
				<div class="row">
					<div class="col-xs-12 col-sm-12">
						<q-editor
							v-model="getCookiesPolicy"
							:toolbar="[
								['bold', 'italic', 'strike', 'underline'],
								['left', 'center', 'right', 'justify'],
								['link', 'upload'],
								[
									{
										label: null,
										icon: 'fas fa-font',
										fixedLabel: true,
										fixedIcon: true,
										list: 'no-icons',
										options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code'],
									},
									{
										label: null,
										icon: 'fas fa-text-height',
										fixedLabel: true,
										fixedIcon: true,
										list: 'no-icons',
										options: [
											'size-1',
											'size-2',
											'size-3',
											'size-4',
											'size-5',
											'size-6',
											'size-7',
										],
									},
									'removeFormat',
								],
								['quote', 'unordered', 'ordered'],
								['custom_btn'],
							]"
							:definitions="{
								bold: { label: null, icon: 'fas fa-bold' },
								italic: { label: null, icon: 'fas fa-italic' },
								strike: { label: null, icon: 'fas fa-strikethrough' },
								underline: { label: null, icon: 'fas fa-underline' },
								left: { label: null, icon: 'fas fa-align-left' },
								center: { label: null, icon: 'fas fa-align-center' },
								right: { label: null, icon: 'fas fa-align-right' },
								justify: { label: null, icon: 'fas fa-align-justify' },
								link: { label: null, icon: 'fas fa-link' },
								upload: {
									tip: null,
									icon: 'fas fa-file-image',
									handler: insertImg,
								},
								removeFormat: { label: null, icon: 'fas fa-eraser' },
								quote: { label: null, icon: 'fas fa-quote-right' },
								unordered: { label: null, icon: 'fas fa-list-ul' },
								ordered: { label: null, icon: 'fas fa-list-ol' },
							}"
						>
							<q-btn
								slot="custom_btn"
								dense
								flat
								color="black"
								icon="fas fa-code"
								label="HTML"
								@click="show_html = true"
							/>
						</q-editor>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_overview' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>

		<q-modal
			v-model="show_html"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_html = false" icon="fas fa-times" />
					<q-toolbar-title>
						HTML
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row">
						<div class="col-12">
							<q-input
								type="textarea"
								rows="10"
								float-label="HTML"
								v-model="getCookiesPolicy"
							/>
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								color="tertiary"
								class="full-width"
								:label="$t('close')"
								icon="fas fa-ban"
								@click="show_html = false"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from 'components/Uploader'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import { BlobServiceClient } from '@azure/storage-blob'

export default {
	name: 'CookiesPolicy',

	i18nOptions: { namespaces: ['common', 'admin'] },

	components: {
		uploader: Uploader,
	},

	data() {
		return {
			tab: 'tab-1',
			cookies_policy: [],
			show_html: false,
			cancel_token: '',
			source: '',
			fileUrl: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			laguages: 'params/languages',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		getCookiesPolicy: {
			get() {
				if (!this.cookies_policy.length) return ''

				let language_id = this.tab.split('-')[1]
				let obj = this.cookies_policy.length
					? this.cookies_policy.find((obj) => obj.language == language_id)
					: null
				if (obj) {
					return obj.body
				} else return ''
			},
			set(newVal) {
				let language_id = this.tab.split('-')[1]
				let obj = this.cookies_policy.length
					? this.cookies_policy.find((obj) => obj.language == language_id)
					: null
				if (obj) {
					obj.body = newVal
				}
			},
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get('/admin_login/cookies_policy/', this.getHeader)
				.then((response) => {
					this.cookies_policy = response.data ? response.data : []

					if (this.cookies_policy.length !== this.laguages.length) {
						this.laguages.map((l) => {
							let obj = this.cookies_policy.length
								? this.cookies_policy.find((obj) => obj.language == l.id)
								: null
							if (!obj) this.cookies_policy.push({ language: l.id, body: '' })
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		saveData() {
			this.$q.loading.show()

			let fd = new FormData()

			let language_id = this.tab.split('-')[1]
			let obj = this.cookies_policy.find((obj) => {
				return obj.language == language_id
			})
			if (obj) {
				fd.append('body', this.$clearEmoticons(obj.body))
				fd.append('language', obj.language)
			}

			this.$axios
				.post('/admin_login/cookies_policy/', fd, this.getHeader)
				.then((response) => {
					this.$q.notify({
						message: this.$t('config_save_successfully'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		insertImg() {
			const input = document.createElement('input')
			input.type = 'file'
			input.accept = '.png, .jpg, .gif'
			let file

			input.onchange = (_) => {
				const files = Array.from(input.files)
				file = files[0]

				this.uploadFile(file)
			}
			input.click()
		},

		uploadFile(file) {
			let date = moment()

			let fd = new FormData()
			fd.append('filename', file.name)
			fd.append(
				'file_directory',
				`media/html_images/cookies_policy/${date.year()}/${date.month() + 1}/`
			)

			this.$axios
				.post('/api/files/policy/', fd, this.getHeader, { cancelToken: this.source.token })
				.then((response) => {
					return new Promise((resolve) => {
						this.$q.loading.show()

						if (response.data.origin === 'azure') {
							const blobServiceClient = new BlobServiceClient(
								`${response.data.base_url}?${response.data.sas_token}`
							)

							const main = async () => {
								const container_client = blobServiceClient.getContainerClient('')

								const block_blob_client = container_client.getBlockBlobClient(
									response.data.filename
								)
								const upload_blob_response = await block_blob_client.uploadBrowserData(
									file
								)

								let fd_complete = new FormData()
								fd_complete.append('uploaded', true)
								fd_complete.append('fileSize', file.size)
								fd_complete.append('file', response.data.file_id)

								if (this.custom_directory) {
									fd_complete.append('not_signed', true)
									fd_complete.append('bucket_name', 'static')
								}

								this.$axios
									.post('/api/files/complete/', fd_complete, this.getHeader)
									.then((response) => {
										this.fileUrl = response.data.fileUrl
										document.execCommand(
											'insertHTML',
											true,
											'<div><img class="uploadBase" src="' +
												this.fileUrl +
												'" style="max-width: 100%" /></div>'
										)
									})
									.finally(() => {
										resolve()
										this.$q.loading.hide()
									})
							}

							main()
						} else {
							let content_type =
								file.type != '' ? file.type : 'application/octet-stream'
							let policy = response.data
							let file_name = policy.filename
							let key_path = policy.file_bucket_path

							let fd_s3 = new FormData()
							fd_s3.append('key', key_path + file_name)
							fd_s3.append('acl', 'private')
							fd_s3.append('Content-Type', content_type)
							fd_s3.append('AWSAccessKeyId', policy.key)
							fd_s3.append('Policy', policy.policy)
							fd_s3.append('filename', file_name)
							fd_s3.append('Signature', policy.signature)
							fd_s3.append('file', file)

							this.cancel_token = this.$axios.CancelToken
							this.source = this.cancel_token.source()

							this.$axios
								.post(process.env.BUCKET_URL, fd_s3, {
									// onUploadProgress: function( event ) {
									//     updateProgress(event.loaded / event.total)
									// },
									// cancelToken: this.source.token
								})
								.then((response) => {
									let fd_complete = new FormData()
									fd_complete.append('uploaded', true)
									fd_complete.append('fileSize', file.size)
									fd_complete.append('file', policy.file_id)

									this.$axios
										.post('/api/files/complete/', fd_complete, this.getHeader)
										.then((response) => {
											let data = {
												file_url: response.data.fileUrl,
											}

											this.$axios
												.post('/utils/presigned_url/', data, this.getHeader)
												.then((response) => {
													document.execCommand(
														'insertHTML',
														true,
														`<div><img class="uploadBase" src="${
															response.data.file_url
														}" style="max-width: 100%" /></div>`
													)
												})
												.catch((e) => {
													console.log(e)
												})
												.finally(() => {
													this.$q.loading.hide()
												})
										})
										.finally(() => {
											this.$q.loading.hide()
										})
								})
								.finally(() => {
									resolve()
								})
						}
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.loading.hide()
				})
		},
	},

	created() {
		this.fetchData()
	},
}
</script>

<style></style>
